// src/components/Pages/PublicLayout/SignoutPage/SignoutPage.jsx
//
// Demo sign-out (Experience Kleido AI): local only, no API calls. Clears this
// device's data except the demo accounts ("users") and the app choice
// ("kleidoAppMode", so /signin stays the demo sign-in), then goes to /signin.

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const KEEP_KEYS = ['users', 'kleidoAppMode'];

function SignOutPage() {
  const navigate = useNavigate();          // ← MUST be here, top-level, no conditionals
  const [dotCount, setDotCount] = useState(0);
  const [isCleaning, setIsCleaning] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    async function signOut() {
      setIsCleaning(true);

      // ── Clean localStorage: remove everything except KEEP_KEYS ──
      const keys = Object.keys(localStorage);
      for (let i = 0; i < keys.length; i++) {
        if (KEEP_KEYS.includes(keys[i])) continue;
        localStorage.removeItem(keys[i]);
      }

      // ── Animate dots 0 → 5 ──
      for (let d = 1; d <= 5; d++) {
        await sleep(300);
        if (cancelled) return;
        setDotCount(d);
      }

      await sleep(800);
      if (cancelled) return;
      setIsCleaning(false);

      // ── Redirect ──
      navigate('/signin', { replace: true });
    }

    signOut();

    return () => { cancelled = true; };
  }, [navigate]);

  const dots = '.'.repeat(dotCount);

  return (
    <>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @keyframes fadeInScale {
          from { opacity: 0; transform: scale(0.5); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>

      <div style={{
        minHeight: '100vh',
        background: '#000000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter, system-ui, sans-serif',
        gap: '24px',
      }}>
        {/* Signing out text with animated dots */}
        <div style={{
          color: '#ffffff',
          fontSize: '20px',
          letterSpacing: '0.5px',
          textShadow: '0 0 12px rgba(255,255,255,0.15)',
          display: 'flex',
          alignItems: 'center',
        }}>
          <span>Signing out now</span>
          <span
            key={dotCount}
            style={{
              animation: 'fadeInScale 0.3s ease-out',
              display: 'inline-block',
              marginLeft: '2px',
            }}
          >
            {dots}
          </span>
        </div>

        {/* Spinner */}
        {isCleaning && (
          <div style={{
            width: '28px',
            height: '28px',
            border: '2px solid rgba(255,255,255,0.15)',
            borderTopColor: '#ffffff',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }} />
        )}
      </div>
    </>
  );
}

export default SignOutPage;
